<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.recurringIndicatorFileNumber')">
              <j-input :placeholder="$t('label.pleaseEnterTheCycleIndexFileNumber')"  v-model="queryParam.stdCycDocCode" ></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.circularIndicatorFileName')">
              <j-input :placeholder="$t('label.pleaseEnterTheNameOfTheCircularIndicatorFile')"  v-model="queryParam.stdCycDocName" ></j-input>
            </a-form-item>
          </a-col>
           <template v-if="toggleSearchStatus">
             <a-col :xl="6" :lg="7" :md="8" :sm="24">
               <a-form-item :label="$t('label.validOrNot')">
                 <j-dict-select-tag  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')" v-model="queryParam.validFlag" dictCode="sfyx"/>
               </a-form-item>
             </a-col>
           </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-std-standard-cycle-modal ref="modalForm" @ok="modalFormOk"></efs-std-standard-cycle-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsStdStandardCycleModal from './modules/EfsStdStandardCycleModal'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'EfsStdStandardCycleList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EfsStdStandardCycleModal,
      JInput
    },
    data () {
      return {
        mainTable: 'efs_std_standard_cycle',
        description: 'efs_std_standard_cycle管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            slotName: 'tableHeader.recurringIndicatorFileNumber',
            scopedSlots: { title: 'tableHeader.recurringIndicatorFileNumber'},
            align:"center",
            dataIndex: 'stdCycDocCode'
          },
          {
            slotName: 'tableHeader.circularIndicatorFileName',
            align:"center",
            dataIndex: 'stdCycDocName',
            scopedSlots: { customRender: 'stdCycDocName', title: 'tableHeader.circularIndicatorFileName'},
          },
          {
            slotName: 'tableHeader.breedingCategory',
            scopedSlots: { title: 'tableHeader.breedingCategory'},
            align:"center",
            dataIndex: 'feedVarietiesId_dictText'
          },
          {
            slotName: 'tableHeader.feedingStage',
            scopedSlots: { title: 'tableHeader.feedingStage'},
            align:"center",
            dataIndex: 'feedStageId'
          },
          {
            slotName: 'tableHeader.cooperationModel',
            scopedSlots: { title: 'tableHeader.cooperationModel'},
            align:"center",
            dataIndex: 'coperModeCode_dictText'
          },
          {
            slotName: 'tableHeader.feedingCycle',
            scopedSlots: { title: 'tableHeader.feedingCycle'},
            align:"center",
            dataIndex: 'feedCycCode_dictText'
          },
          {
            slotName: 'tableHeader.survivalRate',
            scopedSlots: { title: 'tableHeader.survivalRate'},
            align:"center",
            dataIndex: 'survivalRate'
          },
          {
            slotName: 'tableHeader.averageWeightOfAdultChickens',
            scopedSlots: { title: 'tableHeader.averageWeightOfAdultChickens'},
            align:"center",
            dataIndex: 'averageWeight'
          },
          {
            slotName: 'tableHeader.feedingAmount',
            scopedSlots: { title: 'tableHeader.feedingAmount'},
            align:"center",
            dataIndex: 'feedWeight'
          },
          {
            slotName: 'tableHeader.realMeatRatio',
            scopedSlots: { title: 'tableHeader.realMeatRatio'},
            align:"center",
            dataIndex: 'realFmRatio'
          },
          {
            slotName: 'tableHeader.regularRatio',
            scopedSlots: { title: 'tableHeader.regularRatio'},
            align:"center",
            dataIndex: 'normFmRatio'
          },
          {
            slotName: 'tableHeader.serviceCompanyGuaranteePoint',
            scopedSlots: { title: 'tableHeader.serviceCompanyGuaranteePoint'},
            align:"center",
            dataIndex: 'seviCpnyBep'
          },
          {
            slotName: 'tableHeader.seedlingPriceToMeatRatio',
            scopedSlots: { title: 'tableHeader.seedlingPriceToMeatRatio'},
            align:"center",
            dataIndex: 'seedMpr'
          },
          {
            slotName: 'tableHeader.feedToMeatRatio',
            scopedSlots: { title: 'tableHeader.feedToMeatRatio'},
            align:"center",
            dataIndex: 'feedMpr'
          },
          {
            slotName: 'tableHeader.vaccinePriceToMeatRatio',
            scopedSlots: { title: 'tableHeader.vaccinePriceToMeatRatio'},
            align:"center",
            dataIndex: 'vaccinesMpr'
          },
          {
            slotName: 'tableHeader.healthCareMedicinePriceToMeatRatio',
            scopedSlots: { title: 'tableHeader.healthCareMedicinePriceToMeatRatio'},
            align:"center",
            dataIndex: 'hemeMpr'
          },
          {
            slotName: 'tableHeader.treatmentMedicinePriceToMeatRatio',
            scopedSlots: { title: 'tableHeader.treatmentMedicinePriceToMeatRatio'},
            align:"center",
            dataIndex: 'drugMpr'
          },
          {
            slotName: 'tableHeader.priceToMeatRatioForPayingFarmers',
            scopedSlots: { title: 'tableHeader.priceToMeatRatioForPayingFarmers'},
            align:"center",
            dataIndex: 'payFarmerMpr'
          },
          {
            slotName: 'tableHeader.validOrNot',
            scopedSlots: { title: 'tableHeader.validOrNot'},
            align:"center",
            dataIndex: 'validFlag_dictText'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/standardCycle/efsStdStandardCycle/list",
          delete: "/standardCycle/efsStdStandardCycle/delete",
          deleteBatch: "/standardCycle/efsStdStandardCycle/deleteBatch",
          exportXlsUrl: "/standardCycle/efsStdStandardCycle/exportXls",
          importExcelUrl: "/standardCycle/efsStdStandardCycle/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>